/* global graphql */

import React, { Fragment } from "react";

import * as R from "ramda";

import { I18nextProvider } from "react-i18next";

import WebFont from "webfontloader";

import { injectGlobal } from "emotion";

import { Helmet } from "react-helmet";

import i18n from "src/i18n";
import { colors } from "src/styles";

import localeFromPath from "src/locales/fromPath";

import { Box } from "src/components";

import { compose, lifecycle, withState } from "recompose";

injectGlobal`
  * { box-sizing: border-box; };
  body {
    padding: 0px;
    margin: 0px;
    background-color: ${colors.background};
  }
  ::-ms-clear { display: none; }
`;

const enhance = compose(
  withState("fontsLoaded", "setFontsLoaded", false),
  lifecycle({
    componentWillReceiveProps({ locale }) {
      if (locale !== this.props.locale) {
        this.props.i18n.changeLanguage(locale);
      }
    },
    componentDidMount() {
      WebFont.load({
        typekit: {
          id: "orf4sjh",
        },
        google: {
          families: ["Roboto:100,300,400,500"],
        },
        timeout: 2000,
        active: () => {
          this.props.setFontsLoaded(true);
        },
        inactive: () => {
          // Render the screen if fonts aren't loaded within the timeout
          this.props.setFontsLoaded(true);
        },
      });
    },
  })
);

export default enhance(
  ({ data, children, location, renderApp, fontsLoaded, ...props }) => {
    const locale = localeFromPath(location.pathname);
    const siteTitle = R.path(["site", "siteMetadata", "siteTitle"], data);

    return (
      <I18nextProvider i18n={i18n} initialLanguage={locale}>
        {renderApp ? (
          renderApp()
        ) : (
          <Fragment>
            <Helmet titleTemplate={`%s - ${siteTitle}`}>
              <html lang={locale} />
            </Helmet>

            <Box style={{ visibility: fontsLoaded ? "visible" : "hidden" }}>
              {children({
                ...props,
                location,
              })}
            </Box>
          </Fragment>
        )}
      </I18nextProvider>
    );
  }
);

export const query = graphql`
  query MainLayoutQuery {
    site {
      siteMetadata {
        siteUrl
        siteTitle
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js